import { render, staticRenderFns } from "./PostDetailAccept.vue?vue&type=template&id=699286f2&scoped=true"
import script from "./PostDetailAccept.vue?vue&type=script&lang=js"
export * from "./PostDetailAccept.vue?vue&type=script&lang=js"
import style0 from "./PostDetailAccept.vue?vue&type=style&index=0&id=699286f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699286f2",
  null
  
)

export default component.exports